export class ResetPasswordMessage {
  id: string
  password: string
  token: string

  constructor(id: string, password: string, token: string) {
    this.id = id
    this.password = password
    this.token = token
  }
}
    